import { createContext } from "react";

export const ContentViewSwitchContext = createContext();

